import { Box, styled } from '@mui/material';
import { forwardRef } from 'react';
import { IconTileProps, IconTileSize } from './icon-tile.types';

const SIZES: Record<IconTileSize, { tile: string; icon: string; radius: string }> = {
  medium: { tile: '2.125rem', icon: '1.125rem', radius: '0.625rem' },
  small: { tile: '1.375rem', icon: '0.875rem', radius: '0.375rem' },
};

const Tile = styled(Box, {
  name: 'IconTile',
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: IconTileSize }>(({ theme, size }) => ({
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: SIZES[size].tile,
  height: SIZES[size].tile,
  borderRadius: SIZES[size].radius,
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  // Normalize whatever icon node is passed (lucide, MUI, …) to the design's
  // size so the tile looks identical regardless of source.
  '& svg': { width: SIZES[size].icon, height: SIZES[size].icon },
}));

/** Rounded tile that frames an icon consistently across the redesign (page headers, menu rows). */
export const IconTile = forwardRef<HTMLDivElement, IconTileProps>(
  ({ children, size = 'medium', ...rest }, ref) => (
    <Tile ref={ref} aria-hidden size={size} {...rest}>
      {children}
    </Tile>
  ),
);

IconTile.displayName = 'IconTile';
